module.exports = __webpack_public_path__ + "static/img/Exp-ups.2446ea39.png";